/* eslint-disable import/extensions */
/* eslint-disable prettier/prettier */
/* eslint-disable arrow-body-style */
/* eslint-disable import/order */
import React, { useCallback, useMemo, useState, useEffect } from "react";
import { createEditor } from "slate";
import { withHistory } from "slate-history";
import { Slate, Editable, withReact } from "slate-react";
import Toolbar from "./Toolbar/Toolbar";
import { getMarked, getBlock } from "./utils/SlateUtilityFunctions.js";
import withLinks from "./plugins/withLinks.js";
import withTables from "./plugins/withTable.js";
import withEmbeds from "./plugins/withEmbeds.js";
import withEquation from "./plugins/withEquation.js";
import "./Editor.css";
import CodeToText from "./Elements/CodeToText/CodeToText";

const Element = props => {
  return getBlock(props, props.setSize);
};

const Leaf = ({ attributes, children, leaf }) => {
  children = getMarked(leaf, children);
  return <span {...attributes}>{children}</span>;
};

// Função auxiliar para evitar crash se a description estiver vazia ou inválida
const parseDescription = desc => {
  try {
    if (!desc) return [{ type: "paragraph", children: [{ text: "" }] }];
    return typeof desc === "string" ? JSON.parse(desc) : desc;
  } catch (error) {
    return [{ type: "paragraph", children: [{ text: "" }] }];
  }
};

const SlateEditor = ({
  setValorDescricao,
  description,
  editavel,
  placeholder,
  zerar,
  toolbar
}) => {
  const [size, setSize] = useState();

  const [showToolbar, setShowToolbar] = useState(false);

  useEffect(() => {
    if (zerar === true) {
      setValue([
        {
          type: "paragraph", // Corrigido de "paragaph"
          children: [{ text: "" }]
        }
      ]);
    }
  }, [zerar]);

  const editor = useMemo(
    () =>
      withEquation(
        withHistory(
          withEmbeds(withTables(withLinks(withReact(createEditor()))))
        )
      ),
    []
  );

  const [value, setValue] = useState(() => parseDescription(description));

  useEffect(() => {
    if (description !== "") {
      setValue(parseDescription(description));
    }
  }, [description]);

  const handleEditorChange = newValue => {
    setValue(newValue);
    if (setValorDescricao) {
      setValorDescricao(newValue);
    }
  };

  const renderElement = useCallback(
    props => <Element {...props} setSize={setSize} />,
    []
  );

  const renderLeaf = useCallback(props => {
    return <Leaf {...props} />;
  }, []);

  const [htmlAction, setHtmlAction] = useState({
    showInput: false,
    html: "",
    action: "",
    location: ""
  });

  const handleCodeToText = partialState => {
    setHtmlAction(prev => ({
      ...prev,
      ...partialState
    }));
  };

  return (
    <>
      {editavel ? (
        <Slate editor={editor} value={value} onChange={handleEditorChange}>
          {toolbar && (
            <div className="toolbar-toggle-container">
              <button
                type="button"
                className="btn-toggle-toolbar"
                onClick={() => setShowToolbar(!showToolbar)}
              >
                {showToolbar ? "✖" : "Aa"}
              </button>
            </div>
          )}
          {toolbar && showToolbar && (
            <Toolbar handleCodeToText={handleCodeToText} size={size} />
          )}
          <div
            className="editor-wrapper d-flex flex-column flex-1"
            style={{ border: "1px solid #d8dbe0", padding: "0 10px" }}
          >
            <Editable
              placeholder={
                description === "" && placeholder === undefined
                  ? "Digite aqui a descrição"
                  : placeholder
              }
              renderElement={renderElement}
              renderLeaf={renderLeaf}
            />
          </div>

          {htmlAction.showInput && (
            <CodeToText {...htmlAction} handleCodeToText={handleCodeToText} />
          )}
        </Slate>
      ) : (
        <Slate editor={editor} value={parseDescription(description)}>
          <Editable
            renderElement={renderElement}
            renderLeaf={renderLeaf}
            // eslint-disable-next-line react/jsx-boolean-value
            readOnly={true}
          />
        </Slate>
      )}
    </>
  );
};

export default SlateEditor;
